import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AgenceService } from './../../Service/agence.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Global } from '../../Service/global.service';
import * as _ from 'lodash';
import { SharedService } from '../../Service/shared.service';
import { Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'app-historique',
  templateUrl: './historique.component.html',
  styleUrls: ['./historique.component.scss']
})
export class HistoriqueComponent implements OnInit, OnDestroy {

  constructor(private global: Global, private service: AgenceService, private shared: SharedService, private translate: TranslateService) { }
  bloc = {
    Titre: "",
    Contenu: ""
  }
  init = true;
  historiqueData = [];
  curentYear = new Date().getFullYear();
  yearsArray: Array<number> = Array.from(Array(this.curentYear - 1949 + 1).keys())
  subscribe: Subscription;

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      if (!this.init) {
        this.historiqueData = [];
        $('#slider-historique ol').slick('destroy');
      }
      this.service.getHistoriques(lg.url).subscribe(data => {
        this.historiqueData = _.orderBy(data["value"], ['AnneeDebut'], ['asc']);
        this.sliderHistorique(lg.code);
      }, err => {
        this.historiqueData = [];
      })
      this.shared.getBlocDescriptionByCode(lg.url, "Historique1").subscribe(data => {
        this.bloc.Titre = data["value"][0] ? data["value"][0].Title : "";
        this.bloc.Contenu = data["value"][0] ? data["value"][0].Contenu : "";
      })
    })
  }

  ngOnDestroy() {
    //this.subscribe.unsubscribe();
  }

  debutToFin(debut, fin) {
    if (debut == 0) {
      return this.translate.instant("Historique.Avant") + " " + fin;
    } else if (fin == 0) {
      return this.translate.instant("Historique.Apres") + " " + debut;
    } else {
      return debut + "-" + fin;
    }
  }

  sliderHistorique(lg) {
    $("document").ready(() => {
      if (lg == "ar") {
        $('#slider-historique ol').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          rtl: true
        });
      } else {
        $('#slider-historique ol').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        });
      }
      this.init = false;
      var nextHistoryStart = $('.slider-historique ol li').data("year-start");
      var nextHistoryEnd = $('.slider-historique ol li').data("year-end");
      if (nextHistoryStart == 0) {
        nextHistoryStart = 1949
      }
      if (nextHistoryEnd == 0) {
        nextHistoryEnd = this.curentYear
      }
      if (lg == "ar") {
        var p = $('span[data-year=' + nextHistoryStart + ']').position().left;
        var c = $('span[data-year=' + nextHistoryEnd + ']').position().left;
        $('.track').css('width', p - c);
        $('.track').css('left', c);
      } else {
        var p = $('span[data-year=' + nextHistoryStart + ']').position().left;
        var c = $('span[data-year=' + nextHistoryEnd + ']').position().left;
        $('.track').css('width', c - p);
        $('.track').css('left', p);
      }


      $('#slider-historique ol').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        var nextHistoryStart = $('.slick-slide[data-slick-index=' + nextSlide + ']').data("year-start");
        var nextHistoryEnd = $('.slick-slide[data-slick-index=' + nextSlide + ']').data("year-end");
        if (nextHistoryStart == 0) {
          nextHistoryStart = 1949
        }
        if (nextHistoryEnd == 0) {
          nextHistoryEnd = this.curentYear
        }
        if (lg == "ar") {
          var p = $('span[data-year='+nextHistoryStart+']').position().left;
          var c = $('span[data-year=' + nextHistoryEnd +']').position().left;
          $('.track').css('width', p - c);
          $('.track').css('left', c);
        } else {
          var p = $('span[data-year=' + nextHistoryStart + ']').position().left;
          var c = $('span[data-year=' + nextHistoryEnd + ']').position().left;
          $('.track').css('width', c - p);
          $('.track').css('left', p);
        }
        
      });


    });
  }
}
